import { Pressable, PressableProps } from 'react-native'
import { useThrottledCallback } from 'use-debounce'

export type SafePressableProps = PressableProps & { throttle?: number }

const SafePressable = ({ onPress, throttle = 300, ...rest }: SafePressableProps) => {
  const throttled = useThrottledCallback(
    (...args: Parameters<NonNullable<PressableProps['onPress']>>) =>
      onPress?.(...args),
    throttle,
    { leading: true, trailing: false }
  )
  return <Pressable onPress={throttle === 0 ? onPress : throttled} {...rest} />
}

export default SafePressable
